import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormInput, InputType } from '../FormComponents/Input/Input';
import { LabelPosition, SwitchToggle } from '../FormComponents/SwitchToggle';
import { Button, ButtonOption } from '../Fundamentals/Button';
import SpirisIcon from '../Fundamentals/Icon/SpirisIcon';
import Tooltip, { TooltipContent, TooltipTrigger } from '../Overlays/Tooltip';

const FeedbackForm = ({ maxSuggestionLength, onSubmit }) => {
    const { t } = useTranslation();
    const [suggestion, setSuggestion] = useState('');
    const [isPublic, setIsPublic] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const canSubmit = suggestion.trim().length > 0 && !submitting;

    const handleSubmit = () => {
        if (!canSubmit) return;

        setSubmitting(true);
        onSubmit(suggestion.trim(), isPublic)
            .then(() => {
                setSuggestion('');
                setIsPublic(false);
            })
            .catch(() => {})
            .finally(() => setSubmitting(false));
    };

    return (
        <div className="d-flex flex-column gap-16">
            <FormInput type={InputType.TEXTAREA} value={suggestion} onChange={setSuggestion} placeholder={t('feedback.placeholder')} maxLength={maxSuggestionLength} rows={6} disabled={submitting} />
            <div className="d-flex align-items-center justify-content-between gap-16 flex-wrap">
                <div className="d-flex align-items-center">
                    <SwitchToggle
                        label={t('feedback.makePublic')}
                        checked={isPublic}
                        onChange={(checked) => setIsPublic(checked)}
                        id="feedback-visibility"
                        labelPosition={LabelPosition.RIGHT}
                        disabled={submitting}
                    />
                    <Tooltip>
                        <TooltipTrigger>
                            <SpirisIcon name="info" size="sm" filled className="mb-4" />
                        </TooltipTrigger>
                        <TooltipContent>{t('feedback.makePublicHint')}</TooltipContent>
                    </Tooltip>
                </div>

                <Button option={ButtonOption.PRIMARY} disabled={!canSubmit} onClick={handleSubmit}>
                    {t('feedback.submit')}
                </Button>
            </div>
        </div>
    );
};

export default FeedbackForm;
